import dataReducer, { ToolkitDataActions } from "@toolkit/Framework/Store/Toolkit/Data/DataReducer";
import pagesReducer, { ToolkitPagesActions } from "@toolkit/Framework/Store/Toolkit/Pages/PagesReducer";
import { combineReducers } from "redux";

const toolkitReducers = {
    data: dataReducer,
    pages: pagesReducer,
};

export type ToolkitActions = ToolkitDataActions | ToolkitPagesActions;
export default combineReducers(toolkitReducers);
